(function () {
	'use strict';

	if (typeof IntersectionObserver !== 'undefined') {
		var observer = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					entry.target.classList.add('in-view', 'was-in-view');
				}
				else {
					entry.target.classList.remove('in-view');
				}
			});
		}, {threshold: .15});

		document.querySelectorAll('main > *').forEach(function (el) {
			observer.observe(el);
		});
	}
	else {
		var els = document.querySelectorAll('main > *');

		for (var i = 0; i < els.length; i++) {
			els[i].classList.add('in-view', 'was-in-view');
		}
	}
})();
